import { trpc } from "./trpc";
import { showNotification } from "./notification";
import { Logger } from "./logger/Logger";
import posthog from "posthog-js";

export async function sendSharedFileEmail({
	recipientEmail,
	fileName,
	link,
	message,
}: {
	recipientEmail: string;
	fileName: string;
	link: string;
	message: string;
}): Promise<boolean> {
	try {
		await trpc.email.sendSharedFile.mutate({
			recipientEmail,
			fileName,
			link,
			message,
		});
		posthog.capture("email_sent", { email_type: "file_shared" });
		showNotification({
			message: "E-Mail erfolgreich gesendet",
			type: "success",
		});
		return true;
	} catch (err) {
		Logger.error(err, {}, "sendSharedFileEmail");
		showNotification({
			message: "Fehler beim Senden der E-Mail",
			type: "error",
		});
		return false;
	}
}

export async function sendVendorInviteEmail({
	recipientEmail,
	labName,
	message,
}: {
	recipientEmail: string;
	labName: string;
	message?: string;
}) {
	try {
		await trpc.email.sendDentlabVendorInvite.mutate({
			recipientEmail,
			labName,
			message,
		});
		posthog.capture("email_sent", { email_type: "vendor_invitation" });
		showNotification({
			message: "E-Mail erfolgreich gesendet",
			type: "success",
		});
	} catch (err) {
		Logger.error(err, {}, "sendVendorInviteEmail");
		showNotification({
			message: "Fehler beim Senden der E-Mail",
			type: "error",
		});
	}
}

export async function sendTeamInviteEmail({
	recipientEmail,
	labName,
}: {
	recipientEmail: string;
	labName: string;
}) {
	try {
		await trpc.email.sendTeamInvite.mutate({
			recipientEmail,
			labName,
		});
		posthog.capture("email_sent", { email_type: "team_invitation" });
		showNotification({
			message: "E-Mail erfolgreich gesendet",
			type: "success",
		});
	} catch (err) {
		Logger.error(err, {}, "sendTeamInviteEmail");
		showNotification({
			message: "Fehler beim Senden der E-Mail",
			type: "error",
		});
	}
}

export async function sendDentconnectInviteEmail({
	recipientEmail,
	labName,
	message,
}: {
	recipientEmail: string;
	labName: string;
	message: string;
}) {
	try {
		await trpc.email.sendDentconnectInvite.mutate({
			recipientEmail,
			labName,
			message,
		});
		posthog.capture("email_sent", { email_type: "dentconnect_invitation" });
		showNotification({
			message: "E-Mail erfolgreich gesendet",
			type: "success",
		});
	} catch (err) {
		Logger.error(err, {}, "sendDentconnectInviteEmail");
		showNotification({
			message: "Fehler beim Senden der E-Mail",
			type: "error",
		});
	}
}

export async function sendMonatsrechnungSharedEmail({
	recipientEmail,
	labName,
	invoiceNumber,
	link,
	message,
}: {
	recipientEmail: string;
	labName: string;
	invoiceNumber: string;
	link: string;
	message?: string;
}): Promise<boolean> {
	try {
		await trpc.email.sendMonatsrechnungShared.mutate({
			recipientEmail,
			labName,
			invoiceNumber,
			link,
			message,
		});
		posthog.capture("email_sent", { email_type: "monthly_invoice_shared" });
		showNotification({
			message: "E-Mail erfolgreich gesendet",
			type: "success",
		});
		return true;
	} catch (err) {
		Logger.error(err, {}, "sendMonatsrechnungSharedEmail");
		showNotification({
			message: "Fehler beim Senden der E-Mail",
			type: "error",
		});
		return false;
	}
}

export async function sendAkontoRechnungSharedEmail({
	recipientEmail,
	labName,
	invoiceNumber,
	link,
	message,
}: {
	recipientEmail: string;
	labName: string;
	invoiceNumber: string;
	link: string;
	message?: string;
}): Promise<boolean> {
	try {
		await trpc.email.sendAkontoRechnungShared.mutate({
			recipientEmail,
			labName,
			invoiceNumber,
			link,
			message,
		});
		posthog.capture("email_sent", { email_type: "akonto_invoice_shared" });
		showNotification({
			message: "E-Mail erfolgreich gesendet",
			type: "success",
		});
		return true;
	} catch (err) {
		Logger.error(err, {}, "sendAkontoRechnungSharedEmail");
		showNotification({
			message: "Fehler beim Senden der E-Mail",
			type: "error",
		});
		return false;
	}
}

export async function sendMahnungSharedEmail({
	recipientEmail,
	labName,
	reminderLabel,
	invoiceNumber,
	link,
	message,
}: {
	recipientEmail: string;
	labName: string;
	reminderLabel: string;
	invoiceNumber: string;
	link: string;
	message?: string;
}): Promise<boolean> {
	try {
		await trpc.email.sendMahnungShared.mutate({
			recipientEmail,
			labName,
			reminderLabel,
			invoiceNumber,
			link,
			message,
		});
		posthog.capture("email_sent", { email_type: "payment_reminder_shared" });
		showNotification({
			message: "E-Mail erfolgreich gesendet",
			type: "success",
		});
		return true;
	} catch (err) {
		Logger.error(err, {}, "sendMahnungSharedEmail");
		showNotification({
			message: "Fehler beim Senden der E-Mail",
			type: "error",
		});
		return false;
	}
}
